// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import './assets/iconfont/iconfont.css'
import "../config/config"
import Vue from 'vue'
import App from './App'
import router from './router'
import MetaInfo from 'vue-meta-info'

import Vuex from 'vuex'
import store from './store'
import 'normalize.css'
import MintUI from 'mint-ui'
import { Lazyload } from 'mint-ui';
Vue.use(Lazyload);
import 'mint-ui/lib/style.css'
import mixin from './assets/js/mixins'
import Toast from './assets/lib/toast'
import VueLazyLoad from 'vue-lazyload'
Vue.use(VueLazyLoad, {
    error: './static/error.png',
    loading: './static/loading.png'
})
import Vant from 'vant'
import 'vant/lib/index.css'
Vue.use(Vant)


import VModal from 'vue-js-modal'
Vue.use(VModal, { dynamic: true, injectModalsContainer: true, dynamicDefaults: { clickToClose: true } });
// import vConsole from './assets/js/vconsole.js'

import VueJsonp from 'vue-jsonp'
Vue.use(VueJsonp)

Vue.use(Toast);
Vue.mixin(mixin)
Vue.use(MintUI)
Vue.use(MetaInfo)
Vue.use(Vuex)
Vue.config.productionTip = false
import './assets/css/main.scss'
//全局组件

import HomeNav from '@/components/modules/HomeNav';
import DownloadItem from '@/components/modules/DownloadItem';
import CopyrightFooter from '@/components/modules/CopyrightFooter';

Vue.component('home-nav', HomeNav)
Vue.component('download-item', DownloadItem)
Vue.component('copyright-footer', CopyrightFooter)

// https://github.com/xlogiccc/vue-picture-preview
import vuePicturePreview from 'vue-picture-preview';

Vue.component('Previewer', vuePicturePreview);

/* eslint-disable no-new */
//下载地址
Vue.prototype.download_url = 'http://ad.aunbox.cn/r.php?q=https%3A%2F%2Fitunes.apple.com%2Fcn%2Fapp%2Fid1265741262?f=';
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>',
    mounted() {
        // You'll need this for renderAfterDocumentEvent.
        document.dispatchEvent(new Event('render-event'))
    }
})



// WEBPACK FOOTER //
// ./src/main.js